import { Component, Input } from '@angular/core';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';
import { PersonCredential } from 'src/app/shared/models/credential/personCredential';

@Component({
  selector: 'credential-snapshot',
  templateUrl: './credential-snapshot.component.html',
  styleUrls: ['./credential-snapshot.component.scss'],
})
export class CredentialSnapshotComponent {
  @Input()
  credential: PersonCredential;
  @Input()
  showName: boolean = true;

  public CredentialStatusLabelColor = CredentialStatusLabelColor;
}
